import React from "react";
import { Row, Col } from "antd";

const Copywrite = () => {
  return (
    <div className="copywriteSection">
      <div className="container-xxl">
        <Row gutter={16} justify="space-between" align="middle">
          <Col md={12} className="text-left">
            <p>Developed by <a href="https://www.aleaitsolutions.com" target="_blank" rel="noopener noreferrer" style={{ color: "#29e7ff" }}>AleaIT Solutions</a></p>
          </Col>
          <Col md={12} className="text-right" style={{ textAlign: "right" }}>
            <p>Copyright © Floor Detective. All Rights Reserved {(new Date().getFullYear())}</p>
          </Col>
        </Row>
      </div>
    </div>
  );
};


export default Copywrite;
